var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.91.87A2.6492,2.6492,0,0,0,0,3.46,2.6269,2.6269,0,0,0,2.84,6.05h.03A2.6494,2.6494,0,0,0,5.78,3.46,2.6306,2.6306,0,0,0,2.91.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.11,7.75a5.1614,5.1614,0,0,0-4.65,2.45v.05h-.03c.01-.02.02-.03.03-.05l.01-2.12L8.33,8.05c.06,1.41-.08,14.99-.08,14.99l5.14.03.05-8.37a3.181,3.181,0,0,1,.18-1.21,2.8166,2.8166,0,0,1,2.65-1.81c1.86.01,2.6,1.39,2.59,3.4l-.04,8.02,5.14.03.05-8.6C24.02,9.93,21.5,7.77,18.11,7.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 0.31,
    y: 8.1,
    width: 5.14,
    height: 14.99
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.10f45597.svg";
export { ForwardRef as ReactComponent };